import { useNavigate } from 'react-router-dom'
import { Auth0LoginButton } from 'grabbitbot-legacy-ui'
import { AUTH0_LOGIN_EXPECTED_ORIGIN, AUTH0_LOGIN_URL, POST_LOGIN_PATH } from '../../config'

// Equivalent of legacy `UserPasswordsetupValidateComponent`. 2026-09-26
// (owner decision, legacy-migration/RULES.md): `PATCH /user/password/
// validate` now returns `410` — an old emailed password-setup link landing
// here can no longer be completed. Kept registered and points at Auth0
// sign-in/signup.
export function PasswordSetupValidatePage() {
  const navigate = useNavigate()
  return (
    <div className="screener-card screener-card--notice">
      <p role="alert">
        This account-setup link is no longer valid — set up your account by
        signing in.
      </p>
      <Auth0LoginButton
        popupUrl={AUTH0_LOGIN_URL}
        expectedOrigin={AUTH0_LOGIN_EXPECTED_ORIGIN}
        onSuccess={() => navigate(POST_LOGIN_PATH, { replace: true })}
      >
        Log in
      </Auth0LoginButton>
    </div>
  )
}
